//require('./index.css')

var template = require('./index.html')
var locales = require('./locales.json')
var t = require('../translate')
var resource = require('../resource')
var slideto = require('../animation/slideto')
var config = require('app-config')
var { mapState } = require('vuex')

var myMixin = {
  methods: {
    t: function(name) {
      return t(locales, name);
    },
    flt: function(value) {
      return value.toFixed(2).toString();
    }
  }
}
var form = {
  mixins: [myMixin],
  props: ["home_url","swisslink"],
  template: require('./form.html'),
  methods: {
    create_order: function(e) {
      e.preventDefault();
      this.submited = true;
      this.$emit('submited');
      resource.post_form('order', this.order).then((res) => {
        //console.log("post form result: ", res)
        var url = ""
        if(res.url) {
          url = res.url;
        }
        window.location = url;
      });
    },
    is_bank_payment: function() {
      return this.order.payment === 'bank';
    }
  },
  data: function() {
    return {
      submited: false
    }
  },
  watch: {
    'order.payment': function() { fetchPrice(this.$store) },
    'order.quantity': function(newValue) { fetchPrice(this.$store, newValue) },
    'order.country': function() { fetchPrice(this.$store) }
  },
  computed: Object.assign(
    {
      total: function() {
        var o = this.$store.state.order;
        if(o.payment === 'bank') {
          return o.quantity * o.price + o.shipping + o.package;
        }
        else {
          return o.quantity * o.price + o.shipping + o.package + o.paypal_fee;
        }
      }
    },
    mapState({
      order: state => state.order
    })
  )
}

function fetchPrice(store, quantity)
{
  return store.dispatch('FETCH_PRICE', {quantity: quantity?quantity:store.state.order.quantity})
}

module.exports = {
  mixins: [myMixin],
  props: ['country_items','forced_currency'],
  created() {
    var info = {
      country_items: this.country_items,
      country: this.country_items[0]['value']
    }
    if(this.forced_currency) {
      info.forced_currency = this.forced_currency;
    } 

    this.$store.commit('SET_COUNTRY', info)
    fetchPrice(this.$store)
  },
  components: {
    'sell-form': form
  },
  methods: {
    toggle_shop: function() {
      this.shop_open = !this.shop_open;
      if(this.shop_open) {
        setTimeout(function() {
          slideto('#js-order-form');
        },100)
      }
    }
  },
  template: template,
  data: function() {
    return {
      swisslink: false,
      shop_open: false,
      submited: false,
      home_url: config.home_url
    }
  }
}




// WEBPACK FOOTER //
// ./lib/runes-set-order/index.js